/**
 * The telemetry options for partner telemetry events.
 */
export enum TelemetryOptions {
    Measures = 1,
    Telemetry,
    Critical
}
